module.exports = __webpack_public_path__ + "img/phone-refund.b81fa850.webp";